<div class="content-container mt-2">
  <div class="container d-flex flex-column align-items-center">
    <div class="text-center title">Thank you for successfully verifying your pet and personal details. {{ petName }}’s transfer is almost complete.</div>
    <div class="card-container">

      <div class="hero-container-dev">
        <div
          class="hero"
          [style.background-image]="'url(/assets/images/main-plan-card/dog-with-cat.jpeg)'
          "
          [class]="'image-position-cat'"
        >
        </div>

        <div class="container hero-content-text d-flex flex-column">
          <div class="hero-overlay"></div>
          <img
            class="hero-image"
            src="assets/images/main-plan-card/alert-and-TOK.svg"
            alt="alert-and-id"
          />
          <h1 class="mt-2">Transfer of Keepership</h1>
          <p>
            Your transfer of keepership includes immediate access to our premium membership identialert, helping give {{ petName }} pet protection from day 1.
          </p>
          <p>Learn more about your benefits below.</p>
        </div>
        <div class="splodge-container">
          <img
            class="image"
            src="assets/images/main-plan-card/orange-splodge.png"
            alt="orange-splodge"
          />
          <p class="text">The best start in life with pet protection.</p>
        </div>
      </div>

      <div class="content-container">
        <div class="included-list">
          <ul class="image-text-list">
            <li class="list-item">
              <img src="assets/images/main-plan-card/alert-icon.svg" alt="alert-icon" class="list-image" />
              <div class="list-item-text-container">
                <span class="list-item-text-container-title">identialert</span>
                <p>Premium pet protection if the worst happens and your beloved pet goes missing</p>
              </div>
            </li>
            <li class="list-item">
              <img src="assets/images/main-plan-card/id-icon.svg" alt="idIcon" class="list-image" />
              <div class="list-item-text-container">
                <span class="list-item-text-container-title">identibase+</span>
                <p>Unlock your pet’s microchip. Make unlimited changes to pet and personal information</p>
              </div>
            </li>
            <li class="list-item">
              <img src="assets/images/main-plan-card/phone-icon.svg" alt="phone-icon" class="list-image" />
              <div class="list-item-text-container">
                <span class="list-item-text-container-title">identiapp</span>
                <p>Report your pet missing or stolen, view local lost pet alerts and manage your account in one place. It’s pet protection in your pocket!</p>
              </div>
            </li>
            <li class="list-item">
              <div class="list-image"></div>
              <div class="list-item-text-container">
                <span class="list-item-text-container-title">including</span>
                <p>• Vet & Warden alert service<br>• 24/7 missing pet hotline<br>• Tailored missing pet posters<br>• Enhanced online presence<br>• Community mobilisation<br>• Add secondary address</p>
              </div>
            </li>
            <li class="list-item">
              <img src="assets/images/main-plan-card/certificate.svg" alt="phone-icon" class="list-image" />
              <div class="list-item-text-container">
                <span class="list-item-text-container-title">Keeper Certificate</span>
                <p>Access your certificate any time via your online account</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="d-flex flex-column align-items-center justify-content-center">
      <button class="btn btn-secondary text-white btn-lg mt-5 mb-2" (click)="buyTok()">
        <div class="d-flex justify-content-center align-items-center">
          <img width="28" src="assets/images/identibase/whitepawlarge.png" alt="whitepawlarge" class="me-3"/>
          Complete your transfer
        </div>
      </button>
      <div>
        <span class="h4 fw-bold">£</span>
        <span class="h2 fw-bold">36</span>
      </div>
      <p><a href="/terms-and-conditions" target="_blank"><u class="text-dark">Terms and conditions</u></a></p>
    </div>
  </div>
</div>
